// extracted by mini-css-extract-plugin
export default {"idWrapper":"OrderOrValuationId_idWrapper__s1Es-","noPadding":"OrderOrValuationId_noPadding__Qq4d5"};